import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import MainButton from '../common/util/input/MainButton'
import {
    formatUSD,
    formatUSD2,
    formatWAX,
    formatWAXS,
    getUsdWax,
} from '../helpers/FormatLinks'
import {
    getBoostAction,
    signAtomicMarketBuy,
    signNFTHiveBuy,
    signSimpleMarketBuy,
    signWaxplorerBuy,
} from '../helpers/WaxApi'
import LoadingIndicator from '../loadingindicator'
import { useSharedState } from '../waxplorer/Waxplorer'
import PopupWrapperSearch from '../popups/PopupWrapperSearch'

export const MarketButtons = ({
    listing,
    bought,
    canceled,
    className = 'w-full h-8 mt-auto',
    callBack,
    isLoading,
    newOwner,
    onAdd,
    page,
    setIsLoading,
    setSold,
    sold,
    showOwner,
    currentAsset,
    view,
    onOpen,
    setAction,
}) => {
    const [state, dispatch, { login }] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null
    const { t } = useTranslation('common')

    const {
        assets,
        bundle,
        price,
        currency,
        listingId,
        market,
        buyer,
        seller,
        waxPrice,
        usdPrice,
        cancelDate,
        purchaseDate,
    } = listing

    const { template, attributesFloor, blacklisted, schema } =
        assets[currentAsset]

    const { templateId, stats } = template
        ? template
        : { templateId: 0, stats: null }

    const floor = stats?.floorPrice

    const { collection } = assets ? assets[currentAsset] : listing

    let { owner, assetId } = assets[currentAsset]

    const assetIds = []

    if (bundle) {
        assets.forEach((asset) => assetIds.push(asset.assetId))
    } else {
        assetIds.push(assetId)
    }

    const directBuy = async () => {
        const quantity = parseFloat(price)
        setIsLoading(true)

        const usd_wax =
            currency === 'USD' ? await getUsdWax(state) : { usd_wax: 0 }

        try {
            let result
            switch (market) {
                case 'atomicmarket':
                    {
                        result = await signAtomicMarketBuy(
                            activeUser,
                            listingId,
                            quantity,
                            currency,
                            usd_wax['usd_wax'],
                        )

                        callBack(
                            {
                                success: true,
                                error: null,
                                asset: listing,
                                transactionId: result?.response?.transaction_id,
                            },
                            'buy',
                        )
                    }
                    break
                case 'waxplorercom':
                    {
                        result = await signWaxplorerBuy(
                            activeUser,
                            quantity,
                            listingId,
                            assets[0]['assetId'],
                        )

                        callBack(
                            {
                                success: true,
                                error: null,
                                asset: listing,
                                transactionId: result?.response?.transaction_id,
                            },
                            'buy',
                        )
                    }
                    break
                case 'simplemarket':
                    {
                        result = await signSimpleMarketBuy(
                            activeUser,
                            quantity,
                            assetId,
                        )

                        callBack(
                            {
                                success: true,
                                error: null,
                                asset: listing,
                                transactionId: result?.response?.transaction_id,
                            },
                            'buy',
                        )
                    }
                    break
                case 'nft.hive':
                    {
                        result = await signNFTHiveBuy(
                            activeUser,
                            quantity,
                            listingId,
                        )

                        callBack(
                            {
                                success: true,
                                error: null,
                                asset: listing,
                                transactionId: result?.response?.transaction_id,
                            },
                            'buy',
                        )
                    }
                    break
            }
        } catch (e) {
            callBack(
                {
                    success: false,
                    error: e.message,
                    asset: listing,
                },
                'buy',
            )
            console.error(e)
        } finally {
            setIsLoading(false)
        }
    }

    const autoBuyEnabled =
        state.enableLiveAutoBuy && state.enableLiveAutoBuy.price

    useEffect(() => {
        const asyncFunc = async () => {
            if (
                state.enableLiveAutoBuy &&
                (!state.enableLiveAutoBuy.collection ||
                    state.enableLiveAutoBuy.collection ===
                        collection.collectionName) &&
                (!state.enableLiveAutoBuy.schema ||
                    state.enableLiveAutoBuy.schema === schema) &&
                (!state.enableLiveAutoBuy.templateId ||
                    state.enableLiveAutoBuy.templateId.toString() ===
                        templateId.toString()) &&
                page === 'live' &&
                price <= state.enableLiveAutoBuy.price &&
                listing['new'] &&
                buyable
            ) {
                dispatch({
                    type: 'SET_ENABLE_LIVE_AUTOBUY',
                    payload: null,
                })
                state.skipBuyConfirmation ? directBuy() : buy()
            }
        }
        if (autoBuyEnabled) asyncFunc()
    }, [autoBuyEnabled])

    const cancel = async () => {
        let { assets, listingId, market } = listing
        let { assetId, author, symbol, owner } = assets[0]

        if (!market) {
            market = owner
        }

        setIsLoading(true)

        try {
            let result
            switch (market) {
                case 'atomicmarket':
                    result = await activeUser.session.transact(
                        {
                            actions: [
                                getBoostAction(activeUser),
                                {
                                    account: market,
                                    name: 'cancelsale',
                                    authorization: [
                                        {
                                            actor: userName,
                                            permission:
                                                activeUser.requestPermission
                                                    ? activeUser.requestPermission
                                                    : 'active',
                                        },
                                    ],
                                    data: {
                                        sale_id: listingId,
                                    },
                                },
                            ],
                        },
                        {
                            expireSeconds: 300,
                            blocksBehind: 0,
                        },
                    )
                    callBack(
                        {
                            success: true,
                            transactionId: result?.response?.transaction_id,
                        },
                        'cancel',
                    )
                    break
                case 'nft.hive':
                    result = await activeUser.session.transact(
                        {
                            actions: [
                                getBoostAction(activeUser),
                                {
                                    account: 'nft.hive',
                                    name: 'cancelsale',
                                    authorization: [
                                        {
                                            actor: userName,
                                            permission:
                                                activeUser.requestPermission
                                                    ? activeUser.requestPermission
                                                    : 'active',
                                        },
                                    ],
                                    data: {
                                        sale_id: listingId,
                                    },
                                },
                                {
                                    account: 'nft.hive',
                                    name: 'withdraw',
                                    authorization: [
                                        {
                                            actor: userName,
                                            permission:
                                                activeUser.requestPermission
                                                    ? activeUser.requestPermission
                                                    : 'active',
                                        },
                                    ],
                                    data: {
                                        user: userName,
                                        quantity:
                                            (author === 'a.rplanet'
                                                ? (1.0).toFixed(4)
                                                : 1) +
                                            ' ' +
                                            symbol,
                                    },
                                },
                            ],
                        },
                        {
                            expireSeconds: 300,
                            blocksBehind: 0,
                        },
                    )
                    callBack(
                        {
                            success: true,
                            transactionId: result?.response?.transaction_id,
                        },
                        'cancel',
                    )
                    break
                case 'simplemarket':
                    result = await activeUser.session.transact(
                        {
                            actions: [
                                getBoostAction(activeUser),
                                {
                                    account: market,
                                    name: 'cancel',
                                    authorization: [
                                        {
                                            actor: userName,
                                            permission:
                                                activeUser.requestPermission
                                                    ? activeUser.requestPermission
                                                    : 'active',
                                        },
                                    ],
                                    data: {
                                        owner: userName,
                                        assetids: [assetId],
                                    },
                                },
                            ],
                        },
                        {
                            expireSeconds: 300,
                            blocksBehind: 0,
                        },
                    )
                    callBack(
                        {
                            success: true,
                            transactionId: result?.response?.transaction_id,
                        },
                        'cancel',
                    )
                    break
                case 'waxplorercom':
                    result = await activeUser.session.transact(
                        {
                            actions: [
                                getBoostAction(activeUser),
                                {
                                    account: market,
                                    name: 'cancelsale',
                                    authorization: [
                                        {
                                            actor: userName,
                                            permission:
                                                activeUser.requestPermission
                                                    ? activeUser.requestPermission
                                                    : 'active',
                                        },
                                    ],
                                    data: {
                                        sale_id: listingId,
                                    },
                                },
                                {
                                    account: 'simpleassets',
                                    name: 'claim',
                                    authorization: [
                                        {
                                            actor: userName,
                                            permission:
                                                activeUser.requestPermission
                                                    ? activeUser.requestPermission
                                                    : 'active',
                                        },
                                    ],
                                    data: {
                                        claimer: userName,
                                        assetids: assetIds,
                                    },
                                },
                            ],
                        },
                        {
                            expireSeconds: 300,
                            blocksBehind: 0,
                        },
                    )
                    callBack(
                        {
                            success: true,
                            transactionId: result?.response?.transaction_id,
                        },
                        'cancel',
                    )
                    break
            }
        } catch (e) {
            console.error(e)
            setSold(false)
        } finally {
            setIsLoading(false)
        }
    }

    const buy = () => {
        setIsLoading(true)
        setAction('buy')
    }

    const edit = async () => {
        setIsLoading(true)
        setAction('edit')
    }
    const buyContainerClassName = cn(
        'relative grid grid-cols-2 space-x-2 font-bold text-black dark:!text-white block w-full my-auto',
        { 'text-center': view !== 'full' },
        { 'text-left': view === 'full' },
    )
    const singleContainerClassName = cn(
        'mt-auto relative grid font-bold text-black dark:!text-white block text-center grid-cols-1 w-full my-auto',
    )
    const buttonClassName = cn(
        'font-bold rounded-md text-primary',
        { 'm-auto': view !== 'full' },
        { 'mr-auto': view === 'full' },
    )
    const cancelButtonClassName = cn(buttonClassName, 'm-auto w-24 text-white')

    const detailsButton =
        view === 'full' ? (
            ''
        ) : (
            <MainButton
                fullWidth={true}
                className={'font-bold rounded-md text-primary'}
                varient={'bordered'}
                onClick={onOpen}
                padding={'pr-2'}
            >
                {t('asset.details')}
            </MainButton>
        )

    const singleDetailsButton =
        view === 'full' ? (
            ''
        ) : (
            <MainButton
                fullWidth={true}
                className={'font-bold rounded-md text-primary'}
                varient={'bordered'}
                onClick={onOpen}
            >
                {t('asset.details')}
            </MainButton>
        )

    const detailsField = (
        <div className={singleContainerClassName}>{singleDetailsButton}</div>
    )

    const cancelField = (
        <div className={buyContainerClassName}>
            {detailsButton}
            <MainButton className={cancelButtonClassName} onClick={cancel}>
                {t('asset.cancel')}
            </MainButton>
        </div>
    )

    const editField = (
        <div className={buyContainerClassName}>
            {detailsButton}
            <MainButton varient={'solid'} fullWidth={true} onClick={edit}>
                {t('asset.edit')}
            </MainButton>
        </div>
    )

    const buyField =
        page === 'live' ? (
            <div className={singleContainerClassName}>
                <MainButton
                    fullWidth={true}
                    varient={'solid'}
                    onClick={state.skipBuyConfirmation ? directBuy : buy}
                >
                    {t('asset.buy')}
                </MainButton>
            </div>
        ) : (
            <div className={buyContainerClassName}>
                {detailsButton}
                <MainButton
                    fullWidth={true}
                    varient={'solid'}
                    onClick={state.skipBuyConfirmation ? directBuy : buy}
                >
                    {t('asset.buy')}
                </MainButton>
            </div>
        )

    const loginField = (
        <div className={buyContainerClassName}>
            {detailsButton}
            <MainButton
                fullWidth={true}
                varient={'solid'}
                onClick={() => login()}
            >
                {t('navigation.login')}
            </MainButton>
        </div>
    )

    const addField = (
        <div className={singleContainerClassName}>
            <MainButton
                fullWidth={true}
                className={buttonClassName}
                onClick={() => onAdd(listing)}
            >
                {t('trade.add')}
            </MainButton>
        </div>
    )

    let buyable, checked, editable, cancable

    if (
        price &&
        seller &&
        (!userName || userName !== seller) &&
        !bought &&
        market &&
        !cancelDate &&
        !purchaseDate
    ) {
        buyable = true
    } else if (
        userName &&
        (userName === seller || sold) &&
        price &&
        !canceled &&
        !cancelDate &&
        !purchaseDate &&
        ['atomicmarket'].includes(newOwner ? newOwner : market ? market : owner)
    ) {
        editable = true
    } else if (
        userName &&
        (((userName === seller || sold) && market !== 'waxbuyoffers') ||
            (userName === buyer && market === 'waxbuyoffers' && !sold)) &&
        price &&
        !canceled &&
        !cancelDate &&
        !purchaseDate &&
        [
            'nft.hive',
            'waxplorercom',
            'simplemarket',
            'waxinventory',
            'market.myth',
            'alcornftswap',
            'waxarena3dk1',
            'waxbuyoffers',
            'atomicmarket',
        ].includes(newOwner ? newOwner : market ? market : owner)
    ) {
        cancable = true
    }

    const [searchType, setSearchType] = useState(null)
    const [searchAsset, setSearchAsset] = useState(null)

    const setPopupSearch = (searchType, asset) => {
        setSearchType(searchType)
        setSearchAsset(asset)
    }

    return (
        <div className={cn('relative mt-4', className)}>
            <div
                className={cn(
                    'relative py-0 px-0 2xl:px-1 w-full text-base mb-4',
                    'md:text-xs lg:text-base leading-5 flex-wrap text-center min-h-[28px]',
                    { 'text-center': view !== 'full' },
                    { 'text-left': view === 'full' },
                )}
            >
                <PopupWrapperSearch
                    asset={searchAsset}
                    searchType={searchType}
                    setSearchType={setSearchType}
                />
                <div
                    className={cn(
                        'flex h-2/3 flex-col text-left',
                        { 'justify-center mx-auto': view !== 'full' },
                        { 'justify-center mr-auto': view === 'full' },
                    )}
                >
                    {currency === 'USD' && price ? (
                        <div
                            className={
                                'text-xs md:text-base h-6 lg:text-base xl:text-xs text-center mr-auto font-bold'
                            }
                        >
                            <span className="hidden sm:block">
                                <b>{formatUSD2(price)}</b>
                            </span>
                        </div>
                    ) : (
                        ''
                    )}
                    {currency === 'WAX' && price ? (
                        <div
                            className={
                                'text-xs md:text-base h-6 lg:text-base xl:text-xs text-center mr-auto font-bold'
                            }
                        >
                            <span className="hidden sm:block">
                                <b>{formatWAX(price)}</b>
                            </span>
                            <span className="block sm:hidden">
                                <b>{formatWAXS(price)}</b>
                            </span>
                        </div>
                    ) : (
                        ''
                    )}
                    {waxPrice && usdPrice && view !== 'full' ? (
                        <div className={'flex justify-evenly mx-auto'}>
                            <div
                                className={
                                    'text-base lg:text-base text-center m-auto font-bold'
                                }
                            >
                                <span className="hidden sm:block">
                                    <b>{formatWAX(waxPrice)}</b>
                                </span>
                                <span className="block sm:hidden">
                                    <b>{formatWAXS(waxPrice)}</b>
                                </span>
                            </div>
                            <div className={'mx-1'}>/</div>
                            <div
                                className={
                                    'text-xs lg:text-xs text-center m-auto font-bold'
                                }
                            >
                                <span className="hidden sm:block">
                                    <b>{formatUSD(usdPrice)}</b>
                                </span>
                                <span className="block sm:hidden">
                                    <b>{formatWAXS(usdPrice)}</b>
                                </span>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    <div className={'h-[11px]'}>
                        {view !== 'full' && (floor || attributesFloor) ? (
                            <div
                                className={cn(
                                    'flex text-sm md:text-1xs opacity-100 md:opacity-80 h-1/3 hover:opacity-100',
                                    'cursor-pointer my-auto leading-1 ',
                                    { 'justify-start': view !== 'full' },
                                    { 'justify-start': view === 'full' },
                                )}
                                onClick={() =>
                                    setPopupSearch('listings', {
                                        schema: assets[currentAsset].schema,
                                        collection:
                                            assets[currentAsset].collection
                                                .collectionName,
                                        name: assets[currentAsset].name,
                                        owner: assets[currentAsset].owner,
                                        templateId:
                                            assets[currentAsset].template
                                                .templateId,
                                    })
                                }
                            >
                                <p className="text-[11px]">
                                    {!(price && buyer && !price)
                                        ? `${t('asset.floor')}: ${formatWAX(
                                              price
                                                  ? Math.min(
                                                        attributesFloor
                                                            ? attributesFloor
                                                            : floor,
                                                        price,
                                                    )
                                                  : attributesFloor
                                                  ? attributesFloor
                                                  : floor,
                                          )}`
                                        : ''}
                                </p>
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </div>

            <div
                className={
                    'flex h-1/2 my-auto mx-auto mt-auto gap-2 w-full justify-center'
                }
            >
                {!isLoading && !blacklisted && onAdd ? addField : ''}
                {isLoading ? (
                    <LoadingIndicator
                        className={buttonClassName}
                        margin={'m-0'}
                    />
                ) : !blacklisted && !onAdd && buyable ? (
                    userName ? (
                        buyField
                    ) : (
                        loginField
                    )
                ) : !blacklisted && !onAdd && cancable && !editable ? (
                    cancelField
                ) : !blacklisted && !onAdd && editable ? (
                    editField
                ) : !showOwner &&
                  !editable &&
                  !cancable &&
                  !buyable &&
                  !checked &&
                  !sold &&
                  view !== 'full' ? (
                    detailsField
                ) : (
                    ''
                )}
            </div>
        </div>
    )
}

export default MarketButtons
